"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
export const queryClient = new QueryClient();

export function ReactQueryProvider({ children }: { children: any }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
